export const NAVIGATION_ICONS = {
  rectangle: 'https://cdn.naviparking.com/digital_parking/assets/rectangle.svg',
  byNaviparking:
    'https://cdn.naviparking.com/digital_parking/assets/byNaviparking.svg',
  logoDP: 'https://cdn.naviparking.com/digital_parking/assets/logo_dp.svg',
  logoCP: 'https://cdn.naviparking.com/digital_parking/assets/logo_cp.svg',
  checkTick:
    'https://cdn.naviparking.com/digital_parking/assets/check-tick.svg',
  check: 'https://cdn.naviparking.com/digital_parking/assets/check.svg',
  close: 'https://cdn.naviparking.com/digital_parking/assets/close.svg',
  closeWhite:
    'https://cdn.naviparking.com/digital_parking/assets/close-white.svg',
  x: 'https://cdn.naviparking.com/digital_parking/assets/x.svg',
  clockDashed:
    'https://cdn.naviparking.com/digital_parking/assets/clock-dashed.svg',
  digitalParkingDetails:
    'https://cdn.naviparking.com/digital_parking/assets/digital-parking-details.svg',
  cyfrowyParkingDetails:
    'https://cdn.naviparking.com/digital_parking/assets/cyfrowy-parking-details.svg',
  digitalParkingLogo:
    'https://cdn.naviparking.com/digital_parking/assets/digital-parking-logo.svg',
  cyfrowyParkingLogo:
    'https://cdn.naviparking.com/digital_parking/assets/cyfrowy-parking-logo.svg',
  digitalParkingCyanLogo:
    'https://cdn.naviparking.com/digital_parking/assets/digitalParkingCyan.svg',
  cyfrowyParkingCyanLogo:
    'https://cdn.naviparking.com/digital_parking/assets/cyfrowyParkingCyan.svg',
  dropdownIcon:
    'https://cdn.naviparking.com/digital_parking/assets/dropdown-icon.svg',
  list: 'https://cdn.naviparking.com/digital_parking/assets/list.svg',
  selected: 'https://cdn.naviparking.com/digital_parking/assets/selected.svg',
  selectedWhite:
    'https://cdn.naviparking.com/digital_parking/assets/selected-white.svg',
  google: 'https://cdn.naviparking.com/digital_parking/assets/google.svg',
  googleReviews:
    'https://cdn.naviparking.com/digital_parking/assets/googleReviews.svg',
  profile1: 'https://cdn.naviparking.com/digital_parking/assets/profile1.svg',
  profile2: 'https://cdn.naviparking.com/digital_parking/assets/profile2.svg',
  profile3: 'https://cdn.naviparking.com/digital_parking/assets/profile3.svg',
  profile4: 'https://cdn.naviparking.com/digital_parking/assets/profile4.svg',
  info: 'https://cdn.naviparking.com/digital_parking/assets/info.svg',
  warning: 'https://cdn.naviparking.com/digital_parking/assets/warning.svg',
  play: 'https://cdn.naviparking.com/digital_parking/assets/play.svg',
  playButton:
    'https://cdn.naviparking.com/digital_parking/assets/play-button.svg',
  youtube: 'https://cdn.naviparking.com/digital_parking/assets/youtube.svg',
  lang: 'https://cdn.naviparking.com/digital_parking/assets/lang.svg',
  smallDropdown:
    'https://cdn.naviparking.com/digital_parking/assets/smallDropdown.svg',
  linkedin: 'https://cdn.naviparking.com/digital_parking/assets/linkedin.svg',
  locate: 'https://cdn.naviparking.com/digital_parking/assets/locate.svg',
  starIcon: 'https://cdn.naviparking.com/digital_parking/assets/starIcon.svg',
  starFilled:
    'https://cdn.naviparking.com/digital_parking/assets/star-filled.svg',
  star: 'https://cdn.naviparking.com/digital_parking/assets/star.svg',
  starLegia:
    'https://cdn.naviparking.com/digital_parking/assets/star-legia.svg',
  logoCenter:
    'https://cdn.naviparking.com/digital_parking/assets/logo-center.svg',
  search: 'https://cdn.naviparking.com/digital_parking/assets/search.svg',
  searchMobile:
    'https://cdn.naviparking.com/digital_parking/assets/searchMobile.svg',
  map: 'https://cdn.naviparking.com/digital_parking/assets/map.png',
  pinMiniMap:
    'https://cdn.naviparking.com/digital_parking/assets/pinMiniMap.svg',
  mapPin: 'https://cdn.naviparking.com/digital_parking/assets/map-pin.svg',
  parkingMarker:
    'https://cdn.naviparking.com/digital_parking/assets/parking-marker.svg',
  options: 'https://cdn.naviparking.com/digital_parking/assets/options.svg',
  mapButtonMobile:
    'https://cdn.naviparking.com/digital_parking/assets/mapButtonMobile.svg',
  navipay: 'https://cdn.naviparking.com/digital_parking/assets/navipay.svg',
  navipayTitle:
    'https://cdn.naviparking.com/digital_parking/assets/navipay-darkblue-logo.svg',
  darkAppStoreBadge:
    'https://cdn.naviparking.com/digital_parking/assets/dark-app-store-badge.svg',
  darkGooglePlayBadge:
    'https://cdn.naviparking.com/digital_parking/assets/dark-google-play-badge.svg',
  androidAppQRCode:
    'https://cdn.naviparking.com/digital_parking/assets/androidAppQRCode.png',
  iosAppQRCode:
    'https://cdn.naviparking.com/digital_parking/assets/iosAppQRCode.png',
  phoneRinging:
    'https://cdn.naviparking.com/digital_parking/assets/phone-ringing.svg',
  whatsappFilled:
    'https://cdn.naviparking.com/digital_parking/assets/whatsapp-filled.svg',
  pageError:
    'https://cdn.naviparking.com/digital_parking/assets/page-error.svg',
  pageSuccess:
    'https://cdn.naviparking.com/digital_parking/assets/page-success-icon.svg',
  noResults: 'https://cdn.naviparking.com/digital_parking/assets/no-results.svg'
} as const

export type NavigationIconKey = keyof typeof NAVIGATION_ICONS

export const getNavigationIcon = (iconType: NavigationIconKey): string => {
  return NAVIGATION_ICONS[iconType]
}
